/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerGeneratedDocumentType } from './ScreenerGeneratedDocumentType';
import {
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeFromJSONTyped,
    ScreenerGeneratedDocumentTypeToJSON,
} from './ScreenerGeneratedDocumentType';

/**
 * 
 * @export
 * @interface UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner
 */
export interface UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner {
    /**
     * 
     * @type {ScreenerGeneratedDocumentType}
     * @memberof UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner
     */
    type: ScreenerGeneratedDocumentType;
    /**
     * 
     * @type {string}
     * @memberof UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner
     */
    instance_id: string;
}

/**
 * Check if a given object implements the UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner interface.
 */
export function instanceOfUploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "instance_id" in value;

    return isInstance;
}

export function UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSON(json: any): UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner {
    return UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSONTyped(json, false);
}

export function UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': ScreenerGeneratedDocumentTypeFromJSON(json['type']),
        'instance_id': json['instance_id'],
    };
}

export function UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerToJSON(value?: UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': ScreenerGeneratedDocumentTypeToJSON(value.type),
        'instance_id': value.instance_id,
    };
}

